<template>
    <div class="reports-general">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Relatório Simples</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <br>

        <mu-form :model="form">
            <!-- Opções do relatório -->
            <div class="box-options">
                <mu-button :color="`${(form.type=='date'?'primary':'#999999')}`" @click="setReport('date')">
                    <font-awesome-icon icon="calendar-day" class="icon-md icon-margin-left"/>
                    Por Data
                </mu-button>

                <mu-button :color="`${(form.type=='campaign'?'primary':'#999999')}`" @click="setReport('campaign')">
                    <font-awesome-icon icon="comment-dots" class="icon-md icon-margin-left"/>
                    Por Campanha
                </mu-button>
            </div>
            <mu-row gutter>
                <mu-col span="12" sm="6" md="6" lg="6" xl="6">

                    <!-- Seleção da empresa caso for Ziad ou Revenda -->
                    <mu-select label="Selecione a empresa *" filterable no-data-text="Nenhuma empresa encontrada" v-model="form.client_id" full-width @change="loadCampaignsUsers()" v-if="isHaveClients">
                        <mu-option v-for="(item, index) in options.clients" :key="`company_${index}`" :label="item.label" :value="item.id"></mu-option>
                    </mu-select>

                    <div v-show="form.type === 'campaign'">
                        <!-- Campanhas da empresa -->
                        <mu-select label="Selecione a campanha *" filterable no-data-text="Nenhuma campanha encontrada" v-model="form.campaign_id" full-width>
                            <mu-option v-for="(item, index) in options.campaigns" :key="`campaign_${index}`" :label="item.label" :value="item.id"></mu-option>
                        </mu-select>
                    </div>

                    <div v-show="form.type === 'date'">
                        <!-- Data inicial e final -->
                        <mu-row gutter>
                            <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                                <mu-date-input :date.sync="form.start_at" v-model="form.start_at" label="Data inicial *" format="DD-MM-YYYY" :should-disable-date="notAllowedStartDates" :date-time-format="options.format" full-width></mu-date-input>
                            </mu-col>
                            <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                                <mu-date-input :date.sync="form.end_at" v-model="form.end_at" label="Data final *" format="DD-MM-YYYY" :should-disable-date="notAllowedEndDates" :date-time-format="options.format" full-width></mu-date-input>
                            </mu-col>
                        </mu-row>
                    </div>

                    <!-- Selecionar se quer Envios, Recebimentos ou Todos -->
                    <mu-form-item prop="radio" label="Selecione quais as mensagens deseja *">
                        <mu-radio v-model="form.report" value="all" label="Todas"></mu-radio>
                        <mu-radio v-model="form.report" value="sent" label="Envios"></mu-radio>
                        <mu-radio v-model="form.report" value="received" label="Respostas"></mu-radio>
                    </mu-form-item>

                    <!-- Selecionar o formato do arquivo do relatório -->
                    <mu-form-item prop="radio" label="Selecione o formato do arquivo *">
                        <!-- <mu-radio v-model="form.template" value="general-xlsx" label="Excel (.xlsx)"></mu-radio> -->
                        <mu-radio v-model="form.template" value="general-pdf" label="PDF"></mu-radio>
                    </mu-form-item>

                    <!-- Gerar relatório -->
                    <mu-button color="primary" round @click="generateReport()" :disabled="!validateForm()">
                        <font-awesome-icon icon="file-download" class="icon-md icon-margin-left"/>
                        Gerar Relatório
                    </mu-button>

                </mu-col>
                <mu-col span="12" sm="6" md="6" lg="6" xl="6">

                    <div v-show="form.type === 'date' && options.users.length">

                        <!-- Usuários da empresa -->
                        <p>Se preferir pode filtrar por usuários</p>
                        <table class="mu-table">
                            <thead>
                                <tr>
                                    <th width="50"></th>
                                    <th>Usuários</th>
                                    <th>Login</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in options.users" :key="`user_${index}`">
                                    <td><mu-checkbox  v-model="form.users" :value="item.id"></mu-checkbox></td>
                                    <td>{{ item.firstName }} {{ item.lastName }}</td>
                                    <td>{{ item.userName }}</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                </mu-col>
            </mu-row>

            <br>
            <br>
        </mu-form>

    </div>
</template>

<script>
    import moment from 'moment'
    import jsreport from 'jsreport-browser-client-dist'
    import DateFormatCalendar from '@/helpers/calendar'
    import UserService from '@/services/settings/users'
    import ClientService from '@/services/settings/clients'
    import CampaignService from '@/services/services/sms'

    export default {
        name: 'app-reports-dashboard',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Serviços',
                        route: 'app.services',
                        disabled: false
                    },
                    {
                        text: 'Relatórios',
                        route: 'app.services.reports',
                        disabled: false
                    },
                    {
                        text: 'Relatório Simples',
                        disabled: true
                    }
                ],
                options: {
                    format: DateFormatCalendar,
                    clients: [],
                    campaigns: [],
                    users: []
                },
                form: {
                    type: 'date',
                    report: 'all',
                    template: 'general-pdf',
                    start_at: new Date(),
                    end_at: new Date(),
                    client_id: null,
                    campaign_id: null,
                    users: [],
                    title: '',
                    subtitle: '',
                    users_string: ''
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Pegamos os dados da empresa gravadas no STATE
             */
            companie () {
                return this.$store.state.company || null
            },

            /**
             * Verificamos se a empresa logada é uma Revenda ou é a Ziad
             */
            isHaveClients () {
                return this.isZiad() || (this.companie && this.companie.customType === 'R')
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        async mounted () {
            this.setReport('date')
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Carrega a lista de clientes que a revenda logada possui
             */
            async loadClients () {
                try {
                    this.$eventHub.$emit('loading', true, 'Carregando as informações necessárias para gerar o relatório.')

                    let result = await ClientService.all()

                    if (result && result.status) {
                        let arrayOptions = result.results.map((item) => {
                            return {
                                id: item.id,
                                label: item.nick_name
                            }
                        })
                        this.options.clients = [
                            { id: this.companie.id, label: this.companie.name },
                            ...arrayOptions
                        ]
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', 'Não foi possível carregar os clientes.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Carrega os dois
             */
            async loadCampaignsUsers () {
                await this.loadCampaigns()
                await this.loadUsers()
            },

            /**
             * Carrega a lista de usuários com base no ID da empresa selecionada
             */
            async loadCampaigns () {
                try {
                    // ! Somente irá carregar se o tipo do relatório for POR CAMPANHA
                    if (this.form.type !== 'campaign') return

                    this.$eventHub.$emit('loading', true, 'Carregando as campanhas da empresa.')

                    // Definimos o result e zeramos outras propriedades
                    this.form.campaign_id = null
                    this.options.campaigns = []
                    let result

                    if (this.form.client_id) {
                        result = await CampaignService.findByCompanie(this.form.client_id)
                    } else {
                        result = await CampaignService.all()
                    }

                    if (result && result.status && result.results) {
                        this.options.campaigns = result.results.map((item) => {
                            return {
                                id: item.id,
                                label: `${this.dateFormat(item.created_at, true)} - ${item.title}`
                            }
                        })
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', 'Não foi possível carregar as campanhas.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Carregando os usuários da empresa selecionada
             */
            async loadUsers () {
                try {
                    // ! Somente irá carregar se o tipo do relatório for POR DATA
                    if (this.form.type !== 'date') return

                    this.$eventHub.$emit('loading', true, 'Carregando os usuários empresa.')

                    // Definimos o result e zeramos outras propriedades
                    this.form.users = []
                    this.options.users = []
                    let result

                    if (this.form.client_id) {
                        result = await UserService.findByCompanie(this.form.client_id)
                    } else {
                        result = await UserService.all()
                    }

                    if (result && result.status && result.results) {
                        this.options.users = result.results
                        // this.options.users = result.results.map((item) => {
                        //     return {
                        //         id: item.id,
                        //         label: `${item.firstName} ${item.lastName}`
                        //     }
                        // })
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', 'Não foi possível carregar os usuários.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Validação de que datas iremos desabilitar
             * - Datas que são maiores que a data final
             * - Datas que são maiores que 90 dias da data final
             * @param date Data que será feito a validação
             */
            notAllowedStartDates (date) {
                if (date > this.form.end_at || moment(this.form.end_at).diff(date, 'days') > 90) {
                    return true
                }
                return false
            },

            /**
             * Validação de que datas iremos desabilitar
             * - Datas que são menores que a data de inicio
             * - Datas que são maiores que a data atual
             * @param date Data que será feito a validação
             */
            notAllowedEndDates (date) {
                if (date < this.form.start_at || date > new Date()) {
                    return true
                }
                return false
            },

            /**
             * Responsável por dizer qual tipo de relatório irá gerar
             * e tambem altera algumas configurações de acordo com esse tipo
             */
            setReport (type) {
                this.form.client_id = null
                this.form.campaign_id = null
                this.form.users = []
                this.form.type = type

                if (this.isHaveClients) {
                    this.loadClients()
                } else {
                    if (this.form.type === 'campaign') {
                        this.loadCampaigns()
                    } else if (this.form.type === 'date') {
                        this.loadUsers()
                    }
                }
            },

            /**
             * Faz uma validação dos dados antes de enviar
             */
            validateForm () {
                if (!this.form.client_id && this.isHaveClients) return false
                if (this.form.type === 'campaign') {
                    if (!this.form.campaign_id) return false
                } else if (this.form.type === 'date') {
                    if (!this.form.start_at) return false
                    if (!this.form.end_at) return false
                }
                return true
            },

            /**
             * Montando o titulo do relatório
             */
            getTitleReport () {
                if (this.form.type === 'campaign') {
                    return 'Relatório por campanha'
                } else if (this.form.type === 'date') {
                    return 'Relatório por data'
                }
                return ''
            },

            /**
             * Montando o titulo do relatório
             */
            getSubTitleReport () {
                if (this.form.type === 'campaign') {
                    let item = this.options.campaigns.find((item) => {
                        return item.id === this.form.campaign_id
                    })
                    return item ? item.label : ''
                } else if (this.form.type === 'date') {
                    return `${moment(this.form.start_at).format('DD/MM/YYYY')} até ${moment(this.form.end_at).format('DD/MM/YYYY')}`
                }
                return ''
            },

            /**
             * Monta a lista de usuários para impresão no relatório.
             */
            getUsersReportString () {
                if (this.form.type === 'date' && this.form.users && this.form.users.length > 0) {
                    let usersString = this.form.users.map((item) => {
                        let find = this.options.users.find((f) => {
                            return f.id === item
                        })
                        return find ? find.label : ''
                    })
                    return ` - ${usersString.join(', ')}`
                }
                return ''
            },

            /**
             * Criamos uma requisição para API do JSReport com os dados necessários para montar
             * um arquivo de relatório, passamos na propriedade 'data' todas as informações necessárias
             * para a montagem do relatório
             */
            async generateReport () {
                try {
                    this.$eventHub.$emit('loading', true, 'Aguarde... Processando o relatório.')

                    if (!process.env.VUE_APP_JSREPORT_HOST) {
                        this.$eventHub.$emit('snackbar', 'error', 'Não foi possível gerar o relatório.')
                    }

                    let authBasicBase64 = Buffer.from(`${process.env.VUE_APP_JSREPORT_USER}:${process.env.VUE_APP_JSREPORT_PASSWORD}`).toString('base64')

                    // Gerando o título e subtitulo do relatório
                    this.form.title = this.getTitleReport()
                    this.form.subtitle = this.getSubTitleReport()
                    this.form.users_string = this.getUsersReportString()

                    // Verificando se não existir um client_id
                    if (this.form.client_id === null) {
                        this.form.client_id = this.companie.id
                    }

                    // Formatando as datas de inicio e fim
                    this.form.start_at = `${moment(this.form.start_at).format('YYYY-MM-DD')} 00:00:00`
                    this.form.end_at = `${moment(this.form.end_at).format('YYYY-MM-DD')} 23:59:59`

                    jsreport.headers['Authorization'] = 'Basic ' + authBasicBase64
                    jsreport.serverUrl = process.env.VUE_APP_JSREPORT_HOST
                    jsreport.renderAsync({
                        template: {
                            name: this.form.template
                        },
                        data: this.form
                    }).then((res) => {
                        this.$eventHub.$emit('loading', false)
                        let filename = `relatorio-simples-${moment().format('YYYY-MM-DD-HH-mm-ss')}`
                        if (this.form.template === 'general-pdf') {
                            res.download(`${filename}.pdf`)
                        } else if (this.form.template === 'general-xlsx') {
                            res.download(`${filename}.xlsx`)
                        }
                    }).catch(() => {
                        this.$eventHub.$emit('loading', false)
                        this.$eventHub.$emit('snackbar', 'error', 'Ocorreu um problema ao gerar o relatório.')
                    })
                } catch (e) {
                    this.$eventHub.$emit('loading', false)
                    this.$eventHub.$emit('snackbar', 'error', 'Ocorreu um problema ao gerar o relatório..')
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../../../../assets/stylus/bootstrap.styl'

    .mu-select-content
        .mu-selection-text
            display none !important

    .reports-general

        .mu-table
            width 100%
            background none
            color darken($grey, 30%)
            tr
                height auto
                &:hover
                    background lighten($grey, 70%)
                    color #000
                th
                    background lighten($grey, 50%)
                    padding 6px 2px 2px 6px
                    font-size 12px
            td
                padding 6px 2px 2px 6px
                font-size 12px

        table, th, td
            border-collapse collapse

        .box-options
            padding-bottom 15px

            .mu-button
                margin-right 10px

</style>
